/**
* Nom : equipmentSubset.js
* Description : Ce fichier contient la définition de la page equipmentSubset 
*               Cette page affiche les éléments pour gérer les sous-ensembles des produits clients
*               Le terme 'equipment' dans le code correspond à un produit client
* Date de création : 24 juin 2025
*/

/* CSS et assets */
import { AddIcon } from 'package_ui_ihm/dist'

/* Bibliothèques et composants */
import { CompanyBar } from 'package_ui_ihm/dist'
import { TabC } from 'package_ui_ihm/dist'
import { Container } from 'package_ui_ihm/dist'
import { Item } from 'package_ui_ihm/dist'
import { GotoPage } from 'package_ui_ihm/dist'
import { BackPage } from 'package_ui_ihm/dist'
import { SelectFormSide } from 'package_ui_ihm/dist'
import { InputFormSide } from 'package_ui_ihm/dist'
import Divider from '@mui/material/Divider';

/* Hook */
import { useState, useEffect } from 'react'
import { useBlocker } from 'react-router-dom'
import { useAuth } from 'package_ui_ihm/dist'
import { useApi } from 'package_ui_ihm/dist'
import { useScreenWidth } from 'package_ui_ihm/dist'


/**
* EquipmentSubset : affiche la page qui contient les éléments pour gérer les sous-ensembles des produits clients
*                   un formulaire permet de choisir le sous ensemble en fonction du produit 
*                   pour afficher la liste de tout ce type de sous-ensemble existant
*                   un lien permet d'afficher un formulaire pour créer un nouveau sous-ensemble
*                   un lien permet de revenir sur la page qui liste tous les produits client
*
* Type : page 
*
* Parametres : 
*  None
*/
function EquipmentSubset() {

    // Define useState hooks
    const [products, setProducts] = useState([])
    const [selectedProduct, setSelectedProduct] = useState(0)
    const [boxList, setBoxList] = useState([])
    const [selectedBox, setSelectedBox] = useState(0)
    const [boxName, setBoxName] = useState(null)
    const [serialNumber, setSerialNumber] = useState('');
    const [serialNumberError, setSerialNumberError] = useState(false);
    const [version, setVersion] = useState(0);
    const [selectedVersions, setSelectedVersions] = useState(0);
    const [versions, setVersions] = useState([{"id": 1, "name": "Versions 1 et 2.0"}, {"id": 2, "name": "Versions 2.1 et supérieures"}]);
    const [versionError, setVersionError] = useState(false);
    const [powerNumber, setPowerNumber] = useState(0);
    const [powerNumberError, setPowerNumberError] = useState(false);
    const [statusBox, setStatusBox] = useState(null);
    const [isDataLoading, setDataLoading] = useState(false)
    const [isCreation, setCreation] = useState(false)
    const [cpuBoxes, setCpuBoxes] = useState([])
    const [powerBoxes, setPowerBoxes] = useState([])
    const [tunnelBoxes, setTunnelBoxes] = useState([])
    const [roverBoxes, setRoverBoxes] = useState([])
    const [labBoxes, setLabBoxes] = useState([])
    const [stickBoxes, setStickBoxes] = useState([])
    const [ptus, setPtus] = useState([])
    const [ptuTypes, setPtuTypes] = useState([])
    const [selectedPtuType, setSelectedPtuType] = useState(0)
    const [ptuTypeError, setPtuTypeError] = useState(false);
    const [fanOption, setFanOption] = useState(0)
    const [linkPtuTypeLedCardTypes, setLinkPtuTypeLedCardTypes] = useState([])
    const [ledCards, setLedCards] = useState([])
    const [selectedLedCard1, setSelectedLedCard1] = useState(0)
    const [selectedLedCard2, setSelectedLedCard2] = useState(0)
    const [selectedLedCard3, setSelectedLedCard3] = useState(0)
    const [selectedLedCard4, setSelectedLedCard4] = useState(0)
    const [ledCard1Error, setLedCard1Error] = useState(false)
    const [ledCard2Error, setLedCard2Error] = useState(false)
    const [ledCard3Error, setLedCard3Error] = useState(false)
    const [ledCard4Error, setLedCard4Error] = useState(false)
    const [ledCardNumber, setLedCardNumber] = useState(1)
    const [validationDone, setValidationDone] = useState(false)


    // Define useContext hooks
    const { authStatus, authToken, currentUser } = useAuth();
    const { path, previousUrl } = useApi();


    // Define useBlocker hooks
    const shouldBlock = isCreation;
    const blocker = useBlocker(shouldBlock);


    // Define useScreenWidth hooks
    const screenWidth = useScreenWidth();


    // Define functions
    async function sendData(serial_number, version, power_number, ptu_type_id, product_id, fan_option) {
        // Token
        const token = "Bearer " + authToken
        // Création du Form Data
        let form_data = new FormData();
        form_data.append("serial_number", serial_number);
        form_data.append("version", version);
        if(boxName === "Boitier de distribution" || boxName === "Boitier Boxitunnel" || boxName === "Boitier Boxirover")
        {
            form_data.append("number_power_supply", power_number);
        }
        if(boxName === "PTU")
        {
            form_data.append("port", 1);
            form_data.append("PTU_type_id", ptu_type_id);
            form_data.append("fan_option", fan_option);
            form_data.append("product_id", product_id);
        }
        // Create box
        var url;
        if(boxName === 'Boitier CPU'){
            url = path + "/api/eq-cpbo/"
        } else if(boxName === 'Boitier de distribution') {
            url = path + "/api/eq-pobo/"
        } else if(boxName === 'Boitier Boxitunnel') {
            url = path + "/api/eq-tubo/"
        } else if(boxName === 'Boitier Boxirover') {
            url = path + "/api/eq-robo/"
        } else if(boxName === 'Boitier Boxilab') {
            url = path + "/api/eq-labo/"
        } else if(boxName === 'Boitier Boxistick') {
            url = path + "/api/eq-stbo/"
        } else if(boxName === 'PTU') {
            url = path + "/api/eq-mole/"
        }
        const response = await fetch(url, 
            {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                    Authorization: token,
                },
                body: form_data
            }
        );
        setStatusBox(response["status"])
        let resJon = await response.json()
        let module_id = resJon.id
        if(response["status"] === 201){
            // Reset du formulaire
            setCreation(false)
            setSerialNumber('')
            setVersion(0)
            setPowerNumber(0)
            setSelectedPtuType(0)
            setFanOption(0)
            setSelectedLedCard1(0)
            setSelectedLedCard2(0)
            setSelectedLedCard3(0)
            setSelectedLedCard4(0)
            // Update subset list
            if(boxName === 'Boitier CPU'){
                retrieveCpuBoxes()
            } else if(boxName === 'Boitier de distribution') {
                retrievePowerBoxes()
            } else if(boxName === 'Boitier Boxitunnel') {
                retrieveTunnelBoxes()
            } else if(boxName === 'Boitier Boxirover') {
                retrieveRoverBoxes()
            } else if(boxName === 'Boitier Boxilab') {
                retrieveLabBoxes()
            } else if(boxName === 'Boitier Boxistick') {
                retrieveStickBoxes()
            } else if(boxName === 'PTU') {
                // Mise à jour du module_id des cartes LEDs
                for(let selectedLedCard of [selectedLedCard1, selectedLedCard2, selectedLedCard3, selectedLedCard4])
                {
                    if(selectedLedCard !== 0)
                    {
                        let form_data_led_card = new FormData();
                        form_data_led_card.append("module_id", module_id);
                        await fetch(path + "/api/eq-leca/" + selectedLedCard + "/", 
                            {
                                method: 'PATCH',
                                credentials: 'include',
                                mode: 'cors',
                                headers: {
                                    accept: 'application/json',
                                    //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                                    Authorization: token,
                                },
                                body: form_data_led_card
                            }
                        );
                    }
                }
                // Update subset list
                retrievePtus()
            }
        }
        setValidationDone(false)
    }

    const handleClick = (event) => {
        event.preventDefault();
        setCreation(true)
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        // Check of data for box
        if(serialNumber === ''){
            setSerialNumberError(true)
        }
        else
        {   
            setSerialNumberError(false)
        }
        if(version === 0 ){
            setVersionError(true)
        }
        else
        {   
            setVersionError(false)
        }
        if(boxName === 'Boitier de distribution' || boxName === 'Boitier Boxitunnel' || boxName === 'Boitier Boxirover')
        {
            if(powerNumber === 0){
                setPowerNumberError(true)
            }
            else
            {   
                setPowerNumberError(false)
            }
        }
        if(boxName === 'PTU')
        {
            if(selectedPtuType === 0 || selectedPtuType === '0'){
                setPtuTypeError(true)
            }
            else
            {   
                setPtuTypeError(false)
            }
            if(Number(selectedLedCard1) === 0 || selectedLedCard1 === selectedLedCard2 || selectedLedCard1 === selectedLedCard3 || selectedLedCard1 === selectedLedCard4){
                setLedCard1Error(true)
            }
            else
            {   
                setLedCard1Error(false)
            }
            if(ledCardNumber >= 2 && (Number(selectedLedCard2) === 0 || selectedLedCard2 === selectedLedCard1 || selectedLedCard2 === selectedLedCard3 || selectedLedCard2 === selectedLedCard4)){
                setLedCard2Error(true)
            }
            else
            {   
                setLedCard2Error(false)
            }
            if(ledCardNumber >= 3 && (Number(selectedLedCard3) === 0 || selectedLedCard3 === selectedLedCard1 || selectedLedCard3 === selectedLedCard2 || selectedLedCard3 === selectedLedCard4)){
                setLedCard3Error(true)
            }
            else
            {   
                setLedCard3Error(false)
            }
            if(ledCardNumber >= 4 && (Number(selectedLedCard4) === 0 || selectedLedCard4 === selectedLedCard1 || selectedLedCard4 === selectedLedCard2 || selectedLedCard4 === selectedLedCard3)){
                setLedCard4Error(true)
            }
            else
            {   
                setLedCard4Error(false)
            }
        }
        setValidationDone(true)
    };

    const handleReset = (event) => {
        event.preventDefault();
        setCreation(false)
        setSerialNumber('')
        setVersion(0)
        setPowerNumber(0)
        setSelectedPtuType(0)
        setSelectedLedCard1(0)
        setSelectedLedCard2(0)
        setSelectedLedCard3(0)
        setSelectedLedCard4(0)
        setSerialNumberError(false)
        setVersionError(false)
        setPowerNumberError(false)
    };

    async function retrieveData() {
        // Token
        const token = "Bearer " + authToken
        // Products
        const resProd = await fetch(path + "/api/eq-prct/", 
            {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    Authorization: token,
                },
            }
        );
        const dataProd = await resProd.json();
        setProducts(dataProd["results"])
        // Dataloading
        setDataLoading(false)
    }

    function updateBoxListToProduct() {
        setSelectedBox(0)
        if(Number(selectedProduct) === 1){
            let boxitunnel_boxes_dict
            if(Number(selectedVersions) === 1){
                // Sous-ensemble Boxitunnel V1 et V2.0
                boxitunnel_boxes_dict = [{"id": 1, "name": "Boitier CPU"}, {"id": 2, "name": "Boitier de distribution"}, {"id": 3, "name": "PTU"}]
            } else {
                // Sous-ensemble Boxitunnel V2.1 et supérieur
                boxitunnel_boxes_dict = [{"id": 1, "name": "Boitier Boxitunnel"}, {"id": 2, "name": "PTU"}]
            }
            setBoxList(boxitunnel_boxes_dict)
            setLedCardNumber(4)
        }
        else if(Number(selectedProduct) === 2){
            // Sous-ensemble BoxiLab
            const boxilab_boxes_dict = [{"id": 1, "name": "Boitier Boxilab"}, {"id": 2, "name": "PTU"}]
            setBoxList(boxilab_boxes_dict)
            setLedCardNumber(2)
        }
        else if(Number(selectedProduct) === 3){
            // Sous-ensemble Boxistick
            const boxistick_boxes_dict = [{"id": 1, "name": "Boitier Boxistick"}, {"id": 2, "name": "PTU"}]
            setBoxList(boxistick_boxes_dict)
            setLedCardNumber(1)
        }
        else if(Number(selectedProduct) === 4){
            // Sous-ensemble Boxirover
            const boxirover_boxes_dict = [{"id": 1, "name": "Boitier Boxirover"}, {"id": 2, "name": "PTU"}]
            setBoxList(boxirover_boxes_dict)
            setLedCardNumber(4)
        }
        else if(Number(selectedProduct) === 5){
            // Sous-ensemble Boxiclean
            const boxiclean_boxes_dict = [{"id": 1, "name": "PTU"}]
            setBoxList(boxiclean_boxes_dict)
            setLedCardNumber(2)
        } else {
            setBoxName(null)
            setBoxList([])
            setLedCardNumber(1)
        }
    }

    function updateBoxName() {
        if(selectedBox > 0)
        {
            var box_name = boxList.find((box) => (box['id'] === Number(selectedBox)))['name']
            setBoxName(box_name)
            if(box_name === 'Boitier CPU'){
                retrieveCpuBoxes()
            } else if(box_name === 'Boitier de distribution') {
                retrievePowerBoxes()
            } else if(box_name === 'Boitier Boxitunnel') {
                retrieveTunnelBoxes()
            } else if(box_name === 'Boitier Boxirover') {
                retrieveRoverBoxes()
            } else if(box_name === 'Boitier Boxilab') {
                retrieveLabBoxes()
            } else if(box_name === 'Boitier Boxistick') {
                retrieveStickBoxes()
            } else if(box_name === 'PTU') {
                retrievePtus()
            }
        } else {
            setBoxName(null)
        }
    }

    async function retrieveCpuBoxes() {
        // Token
        const token = "Bearer " + authToken
        // Retrieve cpu_box
        const resCpuBox = await fetch(path + "/api/eq-cpbo/", 
            {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    Authorization: token,
                },
            }
        );
        const dataCpuBox = await resCpuBox.json();
        setCpuBoxes(dataCpuBox["results"])
    }

    async function retrievePowerBoxes() {
        // Token
        const token = "Bearer " + authToken
        //Retrieve power_box
        const resPowerBox = await fetch(path + "/api/eq-pobo/", 
            {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    Authorization: token,
                },
            }
        );
        const dataPowerBox = await resPowerBox.json();
        setPowerBoxes(dataPowerBox["results"])
    }

    async function retrieveTunnelBoxes() {
        // Token
        const token = "Bearer " + authToken
        //Retrieve tunnel_box
        const resTunnelBox = await fetch(path + "/api/eq-tubo/", 
            {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    Authorization: token,
                },
            }
        );
        const dataTunnelBox = await resTunnelBox.json();
        setTunnelBoxes(dataTunnelBox["results"])
    }

    async function retrieveRoverBoxes() {
        // Token
        const token = "Bearer " + authToken
        //Retrieve rover box
        const resRoverBox = await fetch(path + "/api/eq-robo/", 
            {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    Authorization: token,
                },
            }
        );
        const dataRoverBox = await resRoverBox.json();
        setRoverBoxes(dataRoverBox["results"])
    }

    async function retrieveLabBoxes() {
        // Token
        const token = "Bearer " + authToken
        // Retrieve lab_box
        const resLabBox = await fetch(path + "/api/eq-labo/", 
            {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    Authorization: token,
                },
            }
        );
        const dataLabBox = await resLabBox.json();
        setLabBoxes(dataLabBox["results"])
    }

    async function retrieveStickBoxes() {
        // Token
        const token = "Bearer " + authToken
        // Retrieve stick_box
        const resStickBox = await fetch(path + "/api/eq-stbo/", 
            {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    Authorization: token,
                },
            }
        );
        const dataStickBox = await resStickBox.json();
        setStickBoxes(dataStickBox["results"])
    }

    async function retrievePtus() {
        // Token
        const token = "Bearer " + authToken
        // Headers
        const headers = {
            accept: 'application/json',
            Authorization: token,
        }
        // Requests in parallel to win time 
        const [resPtu, resPtuType] = await Promise.all([
            // Ptus
            fetch(path + "/api/eq-mole/?product_id=" + selectedProduct, {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
            // Ptus Types
            fetch(path + "/api/eq-ptty/?product_id=" + selectedProduct, {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
        ])
        // Responses in parallel to win time
        const [dataPtu, dataPtuType] = await Promise.all([
            resPtu.json(),
            resPtuType.json(),
        ])
        // Set variables
        setPtus(dataPtu["results"])
        setPtuTypes(dataPtuType["results"])
    }

    async function retrieveLinkPtuTypeLedCardTypes() {
        // Token
        const token = "Bearer " + authToken
        // Retrieve link_PTU_type_led_card_type
        const resLink= await fetch(path + "/api/eq-lpct/?PTU_type_id=" + selectedPtuType, 
            {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    Authorization: token,
                },
            }
        );
        const dataLink = await resLink.json();
        setLinkPtuTypeLedCardTypes(dataLink["results"])
    }

    async function retrieveLedCards() {
        // Token
        const token = "Bearer " + authToken
        // Retrieve led_card
        const resLedCard= await fetch(path + "/api/eq-leca/?module_id=0", 
            {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    Authorization: token,
                },
            }
        );
        const dataLedCard = await resLedCard.json();
        setLedCards(dataLedCard["results"])
    }

    const retrieveFilteredLedCards = (led_card_type_id) => {
        var filteredLedCards = ledCards.filter((ledCard) => ledCard.led_card_type_id === led_card_type_id)
        return filteredLedCards.sort((a, b) => (a.serial_number > b.serial_number)?1:-1)
    };

    const retrieveLedCardListNumber = (index, i, ) => {
        let item_number = 0
        if(index === 0)
        {
            item_number = i + 1
        }
        else 
        {
            for(let k=0; k<index; k++)
            {
                item_number += linkPtuTypeLedCardTypes[index]['led_card_number']
            }
            item_number += i + 1 
        }
        return item_number
    };


    // Define useEffect hooks
    useEffect(() => {
        if(authStatus === 200)
        {
            setDataLoading(true)
            retrieveData()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    useEffect(() => {
        if(Number(selectedProduct) > 1){
            updateBoxListToProduct()
        } 
        else if(Number(selectedProduct) === 1 && Number(selectedVersions) > 0 ){
            updateBoxListToProduct()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedProduct, selectedVersions]);

    useEffect(() => {
        updateBoxName()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedBox]);

    useEffect(() => {
        if(boxName === 'Boitier CPU'){
            retrieveCpuBoxes()
        } else if(boxName === 'Boitier de distribution') {
            retrievePowerBoxes()
        } else if(boxName === 'Boitier Boxitunnel') {
            retrieveTunnelBoxes()
        } else if(boxName === 'Boitier Boxirover') {
            retrieveRoverBoxes()
        } else if(boxName === 'Boitier Boxilab') {
            retrieveLabBoxes()
        } else if(boxName === 'Boitier Boxistick') {
            retrieveStickBoxes()
        } else {
            retrievePtus()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusBox]);

    useEffect(() => {
        retrieveLinkPtuTypeLedCardTypes()
        retrieveLedCards()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedPtuType]);

    useEffect(() => {
        if(validationDone === true && serialNumberError === false && versionError === false && powerNumberError === false && ptuTypeError === false && ledCard1Error === false && ledCard2Error === false && ledCard3Error === false && ledCard4Error === false){
            sendData(serialNumber, version, powerNumber, selectedPtuType, selectedProduct, fanOption)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [validationDone]);

    useEffect(() => {
        // Bloquer la fermeture d'onglet/rafraîchissement
        const handleBeforeUnload = (e) => {
        if (shouldBlock === true) {
            // Standard pour afficher une confirmation (les navigateurs modernes gèrent le message)
            e.preventDefault();
            e.returnValue = "";
            // Certains navigateurs nécessitent cette ligne pour afficher la confirmation
            return (e.returnValue = "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées.");
        }
        }; 

        window.addEventListener("beforeunload", handleBeforeUnload);

        // Nettoyer l'écouteur quand le composant est démonté
        return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldBlock]);

    useEffect(() => {
        if (blocker.state === "blocked") {
            const confirmed = window.confirm(
                "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées."
            );

            if (confirmed) {
                blocker.proceed();
            } else {
                blocker.reset();
            }
        }
    }, [blocker]);


    // Render component
    return (
        <div>
            <CompanyBar name_app="BOXIBRAIN"/>
            <TabC tabNumber={1}/>
            <div className={(screenWidth > 650) ? 'App' : 'App-ss'}>
                <Container>
                    {isDataLoading ? (
                        <p>Chargement des données</p>
                    ) : (
                        <div>
                            <h1>Sous-ensemble de produit client</h1>
                            {/*Lien de retour*/}
                            <div className={(screenWidth > 650) ? 'flex-row justify-center margin-bottom margin-top' : 'grid-1-1 justify-center margin-bottom margin-top'}>
                                <div className='link-border' style={(screenWidth > 650) ? { width: 200 } : null}>
                                    <BackPage path={previousUrl}>Retour</BackPage>
                                </div>
                                <div className='link-border' style={(screenWidth > 650) ? { width: 200 } : null}>
                                    <GotoPage path={'/equipments/ptuType'}>Types de PTUs</GotoPage>
                                </div>
                                <div className='link-border' style={(screenWidth > 650) ? { width: 200 } : null}>
                                    <GotoPage path={'/equipments/ledCard'}>Cartes LEDs</GotoPage>
                                </div>
                                <div className='link-border' style={(screenWidth > 650) ? { width: 200 } : null}>
                                    <GotoPage path={'/equipments/ledCardType'}>Types de cartes LEDs</GotoPage>
                                </div>
                                <div className='link-border' style={(screenWidth > 650) ? { width: 200 } : null}>
                                    <GotoPage path={'/equipments/ledType'}>Types de LEDs</GotoPage>
                                </div>
                            </div>
                            {/*Choix du produit*/}
                            <form className='grid-1-1-1'>
                                <div/>
                                <SelectFormSide error={false} labelText='Choisir le produit' choices={products.sort((a, b) => (a.name > b.name)?1:-1)} choiceParam={'name'} selectedItem={selectedProduct} setSelectedItem={setSelectedProduct}/>
                            </form>
                            {/*Choix de la version dans le cas de Boxitunnel*/}
                            {(Number(selectedProduct) === 1) ? (
                                <form className='grid-1-1-1'>
                                    <div/>
                                    <SelectFormSide error={false} labelText='Choisir la version' choices={versions} choiceParam={'name'} selectedItem={selectedVersions} setSelectedItem={setSelectedVersions}/>
                                </form>
                            ) : (
                                null
                            )}
                            {/*Choix du sous-ensemble*/}
                            <form className='grid-1-1-1'>
                                <div/>
                                <SelectFormSide error={false} labelText='Choisir le sous-ensemble' choices={boxList} choiceParam={'name'} selectedItem={selectedBox} setSelectedItem={setSelectedBox}/>
                            </form>
                            {/*Message d'erreur*/}
                            {(statusBox !== null && statusBox !== 201 && serialNumberError === false && versionError === false && powerNumberError === false) ? (
                                <p className='form-error'>Le sous-ensemble existe déjà ou n'a pas pu être enregistré !</p>
                            ) : (
                                <p/>
                            )} 
                            {/*Liste et formulaire*/}
                            <div className={(screenWidth > 650) ? 'grid-1-3' : null}>
                                <div>
                                    {(selectedProduct > 0 && selectedBox > 0) ? (
                                        /*New*/
                                        (currentUser["role_name"] !== "AT_RESEARCH") ? (
                                            <div className='flex-column'>
                                                <div className='link' onClick={handleClick}>
                                                    <img src={AddIcon} alt='add_item_icon' className='link-img' />
                                                    <div className='link-text'>Sous-ensemble</div>
                                                </div>
                                                {(isCreation === true) ? (
                                                    <div className='flex-rows'>
                                                        <h3>Nouveau {boxName}</h3>
                                                        <form onSubmit={handleSubmit} onReset={handleReset} className='flex-column'>
                                                            <div className='flex-column'>
                                                                <InputFormSide error={serialNumberError} type="text" label="Serial number" value={serialNumber} setValue={setSerialNumber}/>
                                                                <p className='italic-text-note zero-margin-bottom'>Serial number = SN- + numéro de version du sous-ensemble + 4 chiffres</p>
                                                                <p className='italic-text-note margin-bottom'>Exemple: SN-1-0001</p>
                                                                <InputFormSide error={versionError} type="number" label="Version" value={version} setValue={setVersion}/>
                                                                {(boxName === 'Boitier de distribution' || boxName === 'Boitier Boxitunnel' || boxName === 'Boitier Boxirover') ? (
                                                                    <InputFormSide error={powerNumberError} type="number" label="Nombre d'alimentation" value={powerNumber} setValue={setPowerNumber}/>
                                                                ) : (    
                                                                    null
                                                                )}
                                                                {(boxName === 'PTU') ? (
                                                                    <SelectFormSide error={ptuTypeError} labelText="PTU type" choices={ptuTypes} choiceParam={'reference'} selectedItem={selectedPtuType} setSelectedItem={setSelectedPtuType}/>
                                                                ) : (    
                                                                    null
                                                                )}
                                                                {(boxName === 'PTU' && Number(selectedPtuType) > 0 && linkPtuTypeLedCardTypes.length > 0) ? (
                                                                    linkPtuTypeLedCardTypes.map((linkPtuTypeLedCardType, index) => (
                                                                        <div key={index} className='flex-column zero-marge-padding'>
                                                                            <p className='select-form-label'>Type de carte LED {index + 1} : {linkPtuTypeLedCardType["led_card_number"]} cartes</p>
                                                                            {Array.from({ length: linkPtuTypeLedCardType["led_card_number"] }).map((_, i) => (
                                                                                <SelectFormSide key={String(index)+"-"+String(i)} 
                                                                                    error={(retrieveLedCardListNumber(index, i) === 1) ? ledCard1Error : (retrieveLedCardListNumber(index, i) === 2) ? ledCard2Error : (retrieveLedCardListNumber(index, i) === 3) ? ledCard3Error : ledCard4Error} 
                                                                                    labelText={"Carte LED " + String(i+1)} 
                                                                                    choices={retrieveFilteredLedCards(linkPtuTypeLedCardType["led_card_type"]['id'])} 
                                                                                    choiceParam={'serial_number'} 
                                                                                    selectedItem={(retrieveLedCardListNumber(index, i) === 1) ? selectedLedCard1 : (retrieveLedCardListNumber(index, i) === 2) ? selectedLedCard2 : (retrieveLedCardListNumber(index, i) === 3) ? selectedLedCard3 : selectedLedCard4} 
                                                                                    setSelectedItem={(retrieveLedCardListNumber(index, i) === 1) ? setSelectedLedCard1 : (retrieveLedCardListNumber(index, i) === 2) ? setSelectedLedCard2 : (retrieveLedCardListNumber(index, i) === 3) ? setSelectedLedCard3 : setSelectedLedCard4}
                                                                                />
                                                                            ))}
                                                                        </div>
                                                                    ))
                                                                ) : (    
                                                                    null
                                                                )}
                                                                {(boxName === 'PTU' && Number(selectedProduct) === 1) ? (
                                                                    <label className='form-side-label flex-column'>
                                                                        Option ventillateur:
                                                                        <input className='form-checkbox' type="checkbox" value={fanOption} onChange={(e) => setFanOption(e.target.value)} />
                                                                    </label>
                                                                ) : (    
                                                                    null
                                                                )}
                                                            </div>
                                                            <div className='flex-row form-center'>
                                                                <button type="reset" className='button'>Annuler</button>
                                                                <button type="submit" className='button'>Valider</button>
                                                            </div>
                                                        </form> 
                                                    </div>
                                                ) : (
                                                    <div></div>
                                                )}
                                            </div>
                                        ) : (
                                            null
                                        )
                                    ) : (
                                        <div/>
                                    )}
                                </div>
                                {(screenWidth > 650) ? null : <Divider/>}
                                {/*Sous-ensemble list*/}
                                {(boxName === "Boitier CPU") ? (
                                    <div className='scroll-list-rd'>
                                        {(cpuBoxes && cpuBoxes.length !== 0) ? (
                                            cpuBoxes.sort((a, b) => (a.serial_number > b.serial_number)?1:-1).map((cpuBox) => (
                                                <Item key={cpuBox['id']} id={cpuBox['id']}>
                                                    <h3 className='item-text'>SN: {cpuBox['serial_number']} - version : {cpuBox['version']}</h3> 
                                                    {cpuBox['equipment'] ? (
                                                        <p className='item-text'>Produit client {cpuBox['equipment']['serial_number']}</p>
                                                    ) : (
                                                        <p className='item-text'>Non attribué à un produit client</p>
                                                    )}
                                                </Item>
                                            ))
                                        ) : (
                                            <p>Aucun {boxName} actuellement. Veuillez en créer un !</p>
                                        )}
                                    </div>
                                ) : (
                                    (boxName === "Boitier de distribution") ? (
                                        <div className='scroll-list-rd'>
                                            {(powerBoxes && powerBoxes.length !== 0) ? (
                                                powerBoxes.sort((a, b) => (a.serial_number > b.serial_number)?1:-1).map((powerBox) => (
                                                    <Item key={powerBox['id']} id={powerBox['id']}>
                                                        <h3 className='item-text'>SN: {powerBox['serial_number']} - version : {powerBox['version']} - nombre d'alimentation : {powerBox['number_power_supply']}</h3> 
                                                        {powerBox['equipment'] ? (
                                                            <p className='item-text'>Produit client {powerBox['equipment']['serial_number']}</p>
                                                        ) : (
                                                            <p className='item-text'>Non attribué à un produit client</p>
                                                        )}
                                                    </Item>
                                                ))
                                            ) : (
                                                <p>Aucun {boxName} actuellement. Veuillez en créer un !</p>
                                            )}
                                        </div>
                                    ) : (
                                        (boxName === "Boitier Boxitunnel") ? (
                                            <div className='scroll-list-rd'>
                                                {(tunnelBoxes && tunnelBoxes.length !== 0) ? (
                                                    tunnelBoxes.sort((a, b) => (a.serial_number > b.serial_number)?1:-1).map((tunnelBox) => (
                                                        <Item key={tunnelBox['id']} id={tunnelBox['id']}>
                                                            <h3 className='item-text'>SN: {tunnelBox['serial_number']} - version : {tunnelBox['version']} - nombre d'alimentation : {tunnelBox['number_power_supply']}</h3> 
                                                            {tunnelBox['equipment'] ? (
                                                                <p className='item-text'>Produit client {tunnelBox['equipment']['serial_number']}</p>
                                                            ) : (
                                                                <p className='item-text'>Non attribué à un produit client</p>
                                                            )}
                                                        </Item>
                                                    ))
                                                ) : (
                                                    <p>Aucun {boxName} actuellement. Veuillez en créer un !</p>
                                                )}
                                            </div>
                                        ) : (
                                            (boxName === "Boitier Boxilab") ? (
                                                <div className='scroll-list-rd'>
                                                    {(labBoxes && labBoxes.length !== 0) ? (
                                                        labBoxes.sort((a, b) => (a.serial_number > b.serial_number)?1:-1).map((labBox) => (
                                                            <Item key={labBox['id']} id={labBox['id']}>
                                                                <h3 className='item-text'>SN : {labBox['serial_number']} - version : {labBox['version']}</h3> 
                                                                {labBox['equipment'] ? (
                                                                    <p className='item-text'>Produit client {labBox['equipment']['serial_number']}</p>
                                                                ) : (
                                                                    <p className='item-text'>Non attribué à un produit client</p>
                                                                )}
                                                            </Item>
                                                        ))
                                                    ) : (
                                                        <p>Aucun {boxName} actuellement. Veuillez en créer un !</p>
                                                    )}
                                                </div>
                                            ) : (
                                                (boxName === "Boitier Boxistick") ? (
                                                    <div className='scroll-list-rd'>
                                                        {(stickBoxes && stickBoxes.length !== 0) ? (
                                                            stickBoxes.sort((a, b) => (a.serial_number > b.serial_number)?1:-1).map((stickBox) => (
                                                                <Item key={stickBox['id']} id={stickBox['id']}>
                                                                    <h3 className='item-text'>SN : {stickBox['serial_number']} - version : {stickBox['version']}</h3> 
                                                                    {stickBox['equipment'] ? (
                                                                        <p className='item-text'>Produit client {stickBox['equipment']['serial_number']}</p>
                                                                    ) : (
                                                                        <p className='item-text'>Non attribué à un produit client</p>
                                                                    )}
                                                                </Item>
                                                            ))
                                                        ) : (
                                                            <p>Aucun {boxName} actuellement. Veuillez en créer un !</p>
                                                        )}
                                                    </div>
                                                ) : (
                                                    (boxName === "PTU") ? (
                                                        <div className='scroll-list-rd'>
                                                            {(ptus && ptus.length !== 0) ? (
                                                                ptus.sort((a, b) => (a.serial_number > b.serial_number)?1:-1).map((ptu) => (
                                                                    <Item key={ptu['id']} id={ptu['id']}>
                                                                        <h3 className='item-text'>SN : {ptu['serial_number']} - version : {ptu['version']} - type de PTU : {ptu['PTU_type']['reference']}</h3> 
                                                                        <p className='item-text'>
                                                                            SN des cartes LED : 
                                                                            {
                                                                                ptu['led_cards'].map((led_card) => (" " + led_card['serial_number'] + ","))
                                                                            }
                                                                        </p>
                                                                        {ptu['equipment'] ? (
                                                                            <p className='item-text'>Produit client {ptu['equipment']['serial_number']}</p>
                                                                        ) : (
                                                                            <p className='item-text'>Non attribué à un produit client</p>
                                                                        )}
                                                                    </Item>
                                                                ))
                                                            ) : (
                                                                <p>Aucun {boxName} actuellement. Veuillez en créer un !</p>
                                                            )}
                                                        </div>
                                                    ) : (
                                                        (boxName === "Boitier Boxirover") ? (
                                                            <div className='scroll-list-rd'>
                                                                {(roverBoxes && roverBoxes.length !== 0) ? (
                                                                    roverBoxes.sort((a, b) => (a.serial_number > b.serial_number)?1:-1).map((roverBox) => (
                                                                        <Item key={roverBox['id']} id={roverBox['id']}>
                                                                            <h3 className='item-text'>SN: {roverBox['serial_number']} - version : {roverBox['version']} - nombre d'alimentation : {roverBox['number_power_supply']}</h3> 
                                                                            {roverBox['equipment'] ? (
                                                                                <p className='item-text'>Produit client {roverBox['equipment']['serial_number']}</p>
                                                                            ) : (
                                                                                <p className='item-text'>Non attribué à un produit client</p>
                                                                            )}
                                                                        </Item>
                                                                    ))
                                                                ) : (
                                                                    <p>Aucun {boxName} actuellement. Veuillez en créer un !</p>
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <p>Aucun sous-ensemble selectionné actuellement.</p>
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )}
                            </div>
                        </div>
                    )}
                </Container>
            </div>
        </div>
    );
}

export default EquipmentSubset;
